import React, { useEffect, useState } from 'react'
import MUIDataTable from 'mui-datatables'

import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import NotFoundMessage from 'components/NotFoundMessage'
import TableLoadingAnimation from 'components/TableLoadingAnimation'
import { Add } from '@mui/icons-material'
import moment from 'moment/moment'

import { Divider } from '@mui/material'
import { UPLOAD_FILE_TYPE } from 'utils/constants/config'
import generateOptions from '../generateOptions'
import { columns } from './columns'
import { OPERATION_MESSAGES } from "../../../utils/constants/operations"
import { getAllJobRoles } from "../../../services/apiKYE"
import JobRoleFormDialog from "./JobRoleForm"
import FileManagerConfig from '../FileManagerConfig'
import EditBaseHeader from '../EditBaseHeader'

const JobRoleConfig = () => {
  const token = useSelector((state) => state.auth.access_token)

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [isEditorDialogOpen, setIsEditorDialogOpen] = useState(false)
  const [selectedJob, setSelectedJob] = useState(null)

  const handleAdd = () => {
    setIsEditorDialogOpen(true)
  }

  function handleEdit(job) {
    setSelectedJob(job)
    setIsEditorDialogOpen(true)
  }

  const actions = [
    {
      icon: Add,
      callback: handleAdd,
      tooltip_text: 'Adicionar novo registro',
    },
  ]

  const filename = `cargos-${moment().format(
    'DD_MM_YYYY_HH_mm_ss',
  )}`

  const options = generateOptions(filename, actions)

  const loadData = async () => {
    setLoading(true)

    try {
      return await getAllJobRoles(token, {})
    } catch (error) {
      console.error(error)
      toast.error(OPERATION_MESSAGES.LOAD_DATA_FAIL)
      return null
    } finally {
      setLoading(false)
    }
  }

  const initializeDataState = async () => {
    try {
      const responseData = await loadData()

      if (responseData?.length > 0) {
        const transformedData = responseData.map((row) => ({
          ...row,
          actions: {
            edit: () => handleEdit(row),
          },
        }))

        setData(transformedData)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleClose = () => {
    setIsEditorDialogOpen(false)
    setSelectedJob(null)
    initializeDataState()
  }

  useEffect(() => {
    initializeDataState()
  }, [])

  return (
    <div>
      
      <FileManagerConfig fileType={UPLOAD_FILE_TYPE.job_roles_file} baseItemsCount={data?.length} loadingBase={loading} />

      <Divider></Divider>

      <EditBaseHeader />


      {loading ? (
        <TableLoadingAnimation />
      ) : data.length > 0 ? (
        <MUIDataTable data={data} columns={columns} options={options} />
      ) : (
        <NotFoundMessage />
      )}
      <JobRoleFormDialog open={isEditorDialogOpen} job_role={selectedJob} handleClose={handleClose} />
    </div>
  )
}

export default JobRoleConfig
